/* Casa Pau — home: relato, sobre, hilo, nosotros, reveals (sin dependencias) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducido) return;

  function $(id) { return document.getElementById(id); }
  /* umbral 0 + margen: un bloque muy alto (un artículo entero) nunca alcanza
     el 25% visible a la vez, así que basta con que asome por abajo */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
  document.querySelectorAll('.rev, .cose').forEach(function (el) { io.observe(el); });

  var ioVids = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.paused) { var p = v.play(); if (p) p.catch(function(){}); } }
      else if (!v.paused) { v.pause(); }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('video:not([data-relato])').forEach(function (v) { ioVids.observe(v); });

  var ioFrases = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        document.querySelectorAll('.manifiesto .frase').forEach(function (f, i) {
          setTimeout(function () { f.classList.add('leida'); }, 400 + i * 800);
        });
        ioFrases.disconnect();
      }
    });
  }, { threshold: 0.6 });
  var manifiesto = document.querySelector('.manifiesto'); if (manifiesto) ioFrases.observe(manifiesto);

  /* nosotros: hover cambia la foto */
  var nosotrosFotos = document.getElementById('nosotros-fotos');
  var fotos = nosotrosFotos ? nosotrosFotos.children : [];
  var hitos = document.querySelectorAll('#hitos .hito');
  var nosTextos = Array.prototype.map.call(hitos, function (h) { return [h.getAttribute('data-titulo') || '', h.getAttribute('data-texto') || '']; });
  var nosCaja = document.getElementById('nos-texto'), nosTitulo = document.getElementById('nos-titulo'), nosLead = document.getElementById('nos-lead');
  var nosActual = 0;
  function reservarAltura() {
    if (nosCaja.offsetWidth < 200) return;
    var clon = nosCaja.cloneNode(true);
    clon.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;width:' + nosCaja.offsetWidth + 'px;min-height:0';
    nosCaja.parentNode.appendChild(clon);
    var ct = clon.querySelector('#nos-titulo'), cl = clon.querySelector('#nos-lead'), max = 0;
    nosTextos.forEach(function (t) { ct.textContent = t[0]; cl.textContent = t[1]; max = Math.max(max, clon.offsetHeight); });
    clon.remove();
    nosCaja.style.minHeight = max + 'px';
  }
  if (nosCaja) { reservarAltura(); window.addEventListener('resize', reservarAltura); }
  function activa(i) {
    Array.prototype.forEach.call(fotos, function (f, j) { f.classList.toggle('activa', i === j); });
    hitos.forEach(function (h, j) { h.classList.toggle('activa', i === j); });
    if (i === nosActual) return;
    nosActual = i;
    nosCaja.classList.add('cambiando');
    setTimeout(function () { nosTitulo.textContent = nosTextos[i][0]; nosLead.textContent = nosTextos[i][1]; nosCaja.classList.remove('cambiando'); }, 320);
  }
  hitos.forEach(function (h, i) {
    h.addEventListener('mouseenter', function () { activa(i); });
    h.addEventListener('click', function () { activa(i); });
  });

  /* el hilo continuo */
  var crecer = document.getElementById('hilo-crecer');
  var svg = document.getElementById('hilo-svg');
  var path = document.getElementById('hilo-path');
  var docH = 0;
  function tejer() {
    if (!svg || !path) return;
    docH = document.body.scrollHeight;
    var portadaEl = document.getElementById('portada');
    var y0 = (portadaEl ? portadaEl.getBoundingClientRect().top + window.scrollY + portadaEl.offsetHeight : 0) - 20;
    svg.setAttribute('width', 30); svg.setAttribute('height', docH);
    var d = 'M 15 ' + y0, y = y0, lado = 1;
    while (y < docH - 140) {
      var sig = Math.min(y + 460, docH - 140);
      d += ' Q ' + (15 + lado * 9) + ' ' + (y + (sig - y) / 2) + ' 15 ' + sig;
      y = sig; lado = -lado;
    }
    path.setAttribute('d', d);
  }

  function clamp01(x) { return isFinite(x) ? Math.max(0, Math.min(1, x)) : 0; }
  function suave(x) { return 1 - Math.pow(1 - x, 3); }
  function avanceDe(rect) { if (!window.innerHeight) return 0; var t = rect.height - window.innerHeight; return t <= 0 ? 1 : clamp01(-rect.top / t); }

  /* el relato del álbum: escenas con peso (las páginas pasan más rápido) */
  var relatoPista = document.getElementById('relato-pista');
  var medios = document.querySelectorAll('.relato-medio');
  var relatoLinea = document.getElementById('relato-linea');
  var relatoFinal = document.getElementById('relato-final');
  var relatoPie = document.querySelector('.relato-pie');
  var relatoCue = document.getElementById('relato-cue');
  var relatoProg = document.getElementById('relato-progreso');
  var escenas = Array.prototype.map.call(medios, function (m) { return { t: m.getAttribute('data-texto') || '', w: parseFloat(m.getAttribute('data-peso') || '1') }; });
  var pesoFinal = 1.1, acum = [], total = 0;
  escenas.forEach(function (e) { total += e.w; acum.push(total); });
  total += pesoFinal;
  var relatoIdx = -1;

  function ponRelato(idx) {
    if (idx === relatoIdx) return;
    relatoIdx = idx;
    var esFinal = idx >= escenas.length;
    relatoFinal.classList.toggle('actual', esFinal);
    relatoPie.style.opacity = esFinal ? '0' : '1';
    medios.forEach(function (m, i) {
      var activo = !esFinal && i === idx;
      m.classList.toggle('actual', activo);
      var v = m.querySelector('video');
      if (v) { if (activo) { var p = v.play(); if (p) p.catch(function(){}); } else if (!v.paused) { v.pause(); } }
    });
    if (!esFinal) relatoLinea.textContent = escenas[idx].t;
    var cont = document.getElementById('relato-contador'); if (cont && !esFinal) cont.textContent = (idx + 1) + ' / ' + escenas.length;
    relatoCue.style.opacity = idx < 2 ? '1' : '0';
  }

  /* la carta de regalar */
  var cartaPista = document.getElementById('carta-pista');
  var sobre3 = document.getElementById('sobre3');
  var cartaCue = document.getElementById('carta-cue');

  function alScroll() {
    if (crecer) crecer.style.height = Math.min(docH, window.scrollY + window.innerHeight * 0.62) + 'px';

    if (relatoPista && !relatoMovil.matches) {
    var rAv = avanceDe(relatoPista.getBoundingClientRect()) * total;
    var idx = 0; while (idx < acum.length && rAv >= acum[idx]) idx++;
    ponRelato(idx);
    var prog = idx >= escenas.length ? 1 : (idx === 0 ? rAv / acum[0] : (rAv - acum[idx - 1]) / escenas[idx].w);
    relatoProg.style.width = (((Math.min(idx, escenas.length) + clamp01(prog)) / escenas.length) * 100) + '%';
    }

    if (cartaPista) {
    var cAv = avanceDe(cartaPista.getBoundingClientRect());
    sobre3.style.setProperty('--sello', String(suave(clamp01(cAv / 0.28))));
    sobre3.style.setProperty('--zoom', String(suave(clamp01(cAv / 0.34))));
    var solapa = suave(clamp01((cAv - 0.2) / 0.35));
    sobre3.style.setProperty('--solapa', String(solapa));
    sobre3.classList.toggle('girada', solapa > 0.5);
    sobre3.style.setProperty('--papel', String(suave(clamp01((cAv - 0.5) / 0.42))));
    cartaCue.style.opacity = cAv < 0.06 ? '1' : '0';
    }
  }

  /* móvil: el relato se desliza en horizontal y el texto cambia debajo */
  var relatoMovil = window.matchMedia('(max-width: 800px)');
  var marco = document.querySelector('#album .relato-marco');
  if (marco && medios.length) {
    function relatoDeslizado() {
      if (!relatoMovil.matches) return;
      var paso = medios[0].offsetWidth + 12;
      var idx = Math.max(0, Math.min(escenas.length - 1, Math.round(marco.scrollLeft / paso)));
      ponRelato(idx);
      relatoProg.style.width = (((idx + 1) / escenas.length) * 100) + '%';
    }
    marco.addEventListener('scroll', relatoDeslizado, { passive: true });
    function iniciaCarrusel() {
      relatoIdx = -1;
      ponRelato(0);
      relatoProg.style.width = ((1 / escenas.length) * 100) + '%';
      if (relatoCue) relatoCue.textContent = relatoCue.textContent.replace('\u2193', '\u2192');
    }
    if (relatoMovil.matches) iniciaCarrusel();
    if (relatoMovil.addEventListener) relatoMovil.addEventListener('change', function (e) { if (e.matches) iniciaCarrusel(); });
  }

  var pedido = false;
  window.addEventListener('scroll', function () {
    if (!pedido) { pedido = true; requestAnimationFrame(function () { try { alScroll(); } finally { pedido = false; } }); }
  }, { passive: true });
  window.addEventListener('resize', function () { tejer(); alScroll(); });
  window.addEventListener('load', function () { tejer(); alScroll(); });
  try { tejer(); alScroll(); } catch (e) { if (window.console) console.error(e); }
})();

/* menú móvil: cerrar al elegir un destino */
(function () {
  var det = document.querySelector('.header__movil');
  if (!det) return;
  det.querySelectorAll('.header__panel a').forEach(function (a) {
    a.addEventListener('click', function () { det.removeAttribute('open'); });
  });
})();

/* panel de contacto */
(function () {
  var panel = document.getElementById('contacto');
  if (!panel || !panel.showModal) return;
  document.querySelectorAll('a[href="#contacto"]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); panel.showModal(); });
  });
  panel.querySelector('.contacto-cerrar').addEventListener('click', function () { panel.close(); });
  panel.addEventListener('click', function (e) { if (e.target === panel) panel.close(); });
})();


/* páginas de producto: galería, plegables, sobre, canje */
(function () {
  var img = document.getElementById('gal-img'), mini = document.getElementById('gal-mini');
  if (img && mini) {
    var fig = img.parentNode, vid = null;
    mini.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () {
      var src = b.getAttribute('data-src'), vsrc = b.getAttribute('data-video');
      if (vsrc) { if (!vid) { vid = document.createElement('video'); vid.muted = true; vid.loop = true; vid.playsInline = true; vid.autoplay = true; vid.style.cssText = 'width:100%;height:100%;object-fit:cover'; fig.appendChild(vid); } vid.src = vsrc; vid.style.display = 'block'; img.style.display = 'none'; vid.play().catch(function(){}); }
      else { if (vid) { vid.pause(); vid.style.display = 'none'; } img.style.display = 'block'; img.style.opacity = 0; img.style.transform = 'scale(1.03)'; setTimeout(function () { img.src = src; img.removeAttribute('srcset'); img.style.opacity = 1; img.style.transform = 'none'; }, 240); }
      mini.querySelectorAll('button').forEach(function (x) { x.classList.toggle('activa', x === b); }); }); });
  }
  var enlace = document.getElementById('campo-enlace');
  if (enlace) document.querySelectorAll('input[name="properties[Las fotos]"]').forEach(function (r) { r.addEventListener('change', function () { var v = document.querySelector('input[name="properties[Las fotos]"]:checked').value; enlace.classList.toggle('cerrado', v.indexOf('Todavía') === 0); }); });
  var persona = document.getElementById('entrega-persona'), email = document.getElementById('entrega-email'), activar = document.getElementById('rec-activar');
  if (persona && email) {
    var offset = document.getElementById('offset-zona'); if (offset) offset.value = String(new Date().getTimezoneOffset());
    document.querySelectorAll('input[name="properties[Entrega]"]').forEach(function (r) { r.addEventListener('change', function () {
      var porEmail = document.querySelector('input[name="properties[Entrega]"]:checked').getAttribute('data-entrega') === 'email';
      persona.classList.toggle('cerrado', porEmail); email.classList.toggle('cerrado', !porEmail);
      if (activar) activar.checked = porEmail;
      var dir = document.querySelector('input[name="properties[Dirección para el cheque]"]'); if (dir) dir.required = !porEmail;
      ['rec-nombre', 'rec-email'].forEach(function (id) { var el = document.getElementById(id); if (el) el.required = porEmail; });
    }); });
  }
  var sobre = document.getElementById('sobre');
  if (sobre && sobre.classList.contains('sobre-estatico') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setTimeout(function () { sobre.style.setProperty('--sello', '1'); setTimeout(function () { sobre.style.setProperty('--zoom', '1'); }, 300); setTimeout(function () { sobre.style.setProperty('--solapa', '1'); sobre.classList.add('girada'); }, 900); setTimeout(function () { sobre.style.setProperty('--papel', '1'); }, 1700); }, 900);
  }
  ['form-encargo', 'form-vale'].forEach(function (id) { var f = document.getElementById(id); if (!f) return;
    f.addEventListener('submit', function () { f.querySelectorAll('input, textarea').forEach(function (el) { if (el.name && el.name.indexOf('properties[') === 0 && el.type !== 'radio' && el.type !== 'checkbox' && !el.value.trim()) el.disabled = true; }); });
    window.addEventListener('pageshow', function () { f.querySelectorAll('[disabled]').forEach(function (el) { el.disabled = false; }); });
  });
  try {
    var valeUrl = new URLSearchParams(location.search).get('vale'), inputVale = document.getElementById('input-vale');
    if (valeUrl && inputVale) { inputVale.value = valeUrl.replace(/\s+/g, '').toUpperCase(); var cajaVale = document.getElementById('campo-vale'); if (cajaVale) cajaVale.classList.remove('cerrado'); }
  } catch (e) {}
  var fc = document.getElementById('form-canjear');
  if (fc) fc.addEventListener('submit', function (e) {
    e.preventDefault();
    var cod = (document.getElementById('canjear-codigo').value || '').trim().toUpperCase(); if (!cod) return;
    var destino = document.getElementById('input-vale'), caja = document.getElementById('campo-vale');
    if (destino) { destino.value = cod; if (caja) caja.classList.remove('cerrado'); }
    var nota = document.getElementById('canjear-nota'); if (nota) nota.textContent = 'Código guardado en el encargo: ' + cod + '. Al pagar, escribidlo también en el campo "Código de descuento" del pago: el total queda en cero';
    var form = document.getElementById('form-encargo'); if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
